/** @format */

import {createContext} from 'react';
import React from 'react';

// Define the default state
export const defaultState = {
    isLoadingMore: false,
    addedToCart: false,
    isLoading: false,
    orders: [],
    handleFetchOrders: () => {},
    handleRenameQuote: (newLabel, orderId) => {}, // changes the customer label of a quote
    handleAddToCart: () => {},
    handleFetchMore: () => {},
    handleRemove: () => {},
    loadOrders: () => {}
};

// Create the context
export const SavedOrdersContext = createContext(defaultState);
